import { Email } from 'src/models';
import {
  createResource,
  setHideLoader,
  setShowLoader
} from 'src/core/redux/actions';

export const sendEmailAction = (payload) => async (dispatch) => {
  await dispatch(setShowLoader(Email.NAME, ''));

  const response = await dispatch(createResource(Email)(payload));

  await dispatch(setHideLoader(Email.NAME, ''));

  return response;
};
